import { render, staticRenderFns } from "./CGUPage.vue?vue&type=template&id=405b71c3&scoped=true"
import script from "./CGUPage.vue?vue&type=script&lang=js"
export * from "./CGUPage.vue?vue&type=script&lang=js"
import style0 from "./CGUPage.vue?vue&type=style&index=0&id=405b71c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b71c3",
  null
  
)

export default component.exports